var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ele-header"},[_c('div',{class:{
            headContent: _vm.backType == 'blank',
            headContent3: _vm.backType == 'gra',
            headContent4: _vm.backType == 'none',
            headContent2: _vm.backType == 'normal' || !_vm.backType,
        }},[(false)?_c('Svgs',{staticClass:"backBtn",style:(_vm.backStyle),attrs:{"color":_vm.backType == 'normal' ? '#fff' : '#000',"name":"iconfanhui"},nativeOn:{"click":function($event){return _vm.backPath($event)}}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }